import store from '@/store/index';
import EventContact from '@/views/EventContact.vue';
import EventDetail from '@/views/EventDetail.vue';
import Events from '@/views/Events.vue';
import EventSchedule from '@/views/EventSchedule.vue';
import FamousScholar from '@/views/FamousScholar.vue';
import ForgetPassword from '@/views/ForgetPassword.vue';
/*--- 导入自定义组件 ---*/
import Home from '@/views/Home.vue';
import MobilRegistration from '@/views/MobileRegistration.vue';
import MyEvents from '@/views/MyEvents.vue';
import MyInfo from '@/views/MyInfo.vue';
import MyRegistrationForm from '@/views/MyRegistrationForm.vue';
import MyThesisList from '@/views/MyThesisList.vue';
import RePWDSuccess from '@/views/RePWDSuccess.vue';
import ResetPasswordEmailSend from '@/views/ResetPasswordEmailSend.vue';
import SafeSettings from '@/views/SafeSettings.vue';
import SetNewPassword from '@/views/SetNewPassword.vue';
import SubEvent from '@/views/SubEvent.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '中国经济学年会系统' },
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    meta: { title: '会议活动 - 中国经济学年会' },
  },
  {
    path: '/eventDetail',
    name: 'EventDetail',
    component: EventDetail,
    // meta: { title: '会议详情' },
  },
  {
    path: '/subEvent',
    name: 'SubEvent',
    component: SubEvent,
    // meta: { title: '分会议日程' },
  },
  {
    path: '/eventSchedule',
    name: 'EventSchedule',
    component: EventSchedule,
    // meta: { title: '会议日程安排' },
  },
  {
    path: '/famousScholar',
    name: 'FamousScholar',
    component: FamousScholar,
    // meta: { title: '知名学者' },
  },
  {
    path: '/eventContact',
    name: 'EventContact',
    component: EventContact,
    // meta: { title: '联系方式' },
  },
  {
    path: '/myEvents',
    name: 'MyEvents',
    component: MyEvents,
    meta: { title: '我的会议', requireAuth: true },
  },
  {
    path: '/myInfo',
    name: 'MyInfo',
    component: MyInfo,
    meta: { title: '个人基础信息', requireAuth: true },
  },
  {
    path: '/safeSettings',
    name: 'SafeSettings',
    component: SafeSettings,
    meta: { title: '安全设置', requireAuth: true },
  },
  {
    path: '/myRegistrationForm',
    name: 'MyRegistrationForm',
    component: MyRegistrationForm,
    meta: { title: '我的报名表', requireAuth: true },
  },
  {
    path: '/myThesisList',
    name: 'MyThesisList',
    component: MyThesisList,
    meta: { title: '我的投稿', requireAuth: true },
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: { title: '忘记密码' },
  },
  {
    path: '/resetPasswordEmailSend',
    name: 'ResetPasswordEmailSend',
    component: ResetPasswordEmailSend,
    meta: { title: '重置密码邮件已发送' },
  },
  {
    path: '/setNewPassword',
    name: 'SetNewPassword',
    component: SetNewPassword,
    meta: { title: '设置新密码' },
  },
  {
    path: '/rePWDSuccess',
    name: 'RePWDSuccess',
    component: RePWDSuccess,
    meta: { title: '新密码设置成功' },
  },
  {
    path: '/mobileRegistration',
    name: 'mobileRegistration',
    component: MobilRegistration,
    meta: { title: '报名' },
  },
  { path: '*', redirect: '/' }, //默认跳转
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 判断localstorage里面是否有token
  const isLogin = localStorage.eleToken ? true : false;
  console.log(isLogin);
  if (to.meta.requireAuth) {
    if (isLogin === true) {
      next();
    } else {
      next({
        path: '/',
        query: { redirect: to.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
      // 这里的store 是从@/store/index.js中引入来的
      store.commit('blOpenLoginBox', true);
    }
  } else {
    next();
  }
  // 页面title
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    window.document.title = to.meta.title;
  }
  next();
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
